import { useContext, useEffect, useState } from "react";

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  Tooltip,
} from "@material-ui/core";
import {
  ExpandMore,
  DeleteOutlineOutlined,
  EditOutlined,
  Add,
} from "@material-ui/icons";

import {
  HeaderAccordion,
  HeaderCard,
  IconButtonStyled,
  TableContent,
} from "../styles/Produto";
import TableDefault from "../../../../components/grid/TableDefault";
import { ProdutoContext } from "../contexts/ProdutoContext";
import useProdutoController from "../controllers/ProdutoController";
import ModalProdutoOutroFornecedor from "./ModalProdutoOutroFornecedor";
import Chip from "../../../../components/basics/Chip";
import SelectErp from "../../../../components/basics/SelectErp";
import TextFieldErp from "../../../../components/basics/TextFieldErp";
import Card from "../../../../components/cards/Card";
import SpeedDialErp from "../../../../components/speeddial/SpeedDialErp";

import { QueryParamsContext } from "../../../../context/QueryParamsContext";

export default function AccordionProdutoFornecedor() {
  const {
    //Principal
    mainStockUnit,

    //Fornecedores
    supplier,
    setSupplier,
    supplierRef,
    setSupplierRef,
    supplierPurchaseUnit,
    setSupplierPurchaseUnit,
    supplierDescription,
    setSupplierDescription,
    supplierConversionFactor,
    setSupplierConversionFactor,
    supplierOthers,
    setSupplierOthers,

    listSupplier,
    listUnits,
    expanded,
    errors,
    loadingInputs,
  } = useContext(ProdutoContext);

  const { queryParams } = useContext(QueryParamsContext);

  const {
    handleChangeOpenAcordion,
    handleRemoveItemTable,
    handleEditItemTable,
  } = useProdutoController();
  const [open, setOpen] = useState(false);
  const [rowEdit, setRowEdit] = useState(null);
  const [dataTable, setDataTable] = useState([]);
  const [ableToSelect, setAbleToSelect] = useState([]);

  const show = queryParams.idversao !== "16";

  const columns = [
    {
      id: "acoes",
      label: "Ações",
      align: "center",
      format: (item) => {
        const actions = [
          {
            name: "Deletar",
            icon: <DeleteOutlineOutlined />,
            action: () =>
              handleRemoveItemTable(
                setDataTable,
                setSupplierOthers,
                supplierOthers,
                item.index
              ),
          },
          {
            name: "Editar",
            icon: <EditOutlined />,
            action: () =>
              handleEditItemTable(setOpen, setRowEdit, item, item.index),
          },
        ];

        return <SpeedDialErp actions={actions} />;
      },
    },
    {
      id: "nomefornecedor",
      label: "Fornecedor",
    },
  ];

  useEffect(() => {
    const existentIds = dataTable.map((tableItem) => tableItem.idfornecedor);
    const allowedToRegister = [];
    listSupplier.forEach((listItem) => {
      if (!existentIds.includes(listItem.id)) {
        allowedToRegister.push(listItem.id);
      }
    });

    setAbleToSelect(allowedToRegister);
  }, [dataTable, listSupplier]);

  useEffect(() => {
    const newList = supplierOthers.map((item, index) => {
      let nomefornecedor = item?.idfornecedor
        ? listSupplier.find(
            (supplierIndex) =>
              supplierIndex.id === item?.idfornecedor ||
              supplierIndex.id === item?.id
          )
        : "";
      nomefornecedor = nomefornecedor ? nomefornecedor.apelido : "";

      return {
        ...item,
        nomefornecedor,
        index,
      };
    });

    setDataTable(newList);
  }, [supplierOthers, listSupplier]);

  return (
    <>
      <ModalProdutoOutroFornecedor
        open={open}
        setOpen={setOpen}
        setRowEdit={setRowEdit}
        rowEdit={rowEdit}
        ableToSelect={ableToSelect}
      />
      <Grid item xs={12}>
        <Accordion
          expanded={expanded.otherSuppliers || false}
          onChange={() => handleChangeOpenAcordion("otherSuppliers")}
        >
          <AccordionSummary
            expandIcon={<ExpandMore />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <HeaderAccordion>
              <Grid container spacing={1} alignItems="center">
                <Grid item xs={12}>
                  <Chip
                    label="FORNECEDORES"
                    bgcolor={
                      !expanded.otherSuppliers &&
                      errors.accordions &&
                      errors.accordions.includes("otherSuppliers")
                        ? "red"
                        : "default"
                    }
                    textcolor={
                      !expanded.otherSuppliers &&
                      errors.accordions &&
                      errors.accordions.includes("otherSuppliers")
                        ? "white"
                        : "default"
                    }
                  />
                </Grid>
              </Grid>
            </HeaderAccordion>
          </AccordionSummary>

          <AccordionDetails>
            <Grid container spacing={2}>
              {show && (
                <Grid item md={6} xs={12}>
                  <Card line="left" lineColor="primary">
                    <HeaderCard style={{ marginBottom: "20px" }}>
                      <Grid container>
                        <Chip
                          label="FORNECEDOR PRINCIPAL"
                          bgcolor="secondary"
                        />
                      </Grid>
                    </HeaderCard>

                    <Grid container spacing={2}>
                      <Grid item lg={6} md={6} sm={12} xs={12}>
                        <SelectErp
                          error={errors.supplier ? true : false}
                          helperText={errors.supplier || ""}
                          loading={loadingInputs.listSupplier || false}
                          label="Fornecedor"
                          value={supplier}
                          setValue={setSupplier}
                          optionsList={listSupplier}
                          descriptionField="razao"
                        />
                      </Grid>

                      <Grid item lg={6} md={6} sm={12} xs={12}>
                        <TextFieldErp
                          error={errors.supplierRef ? true : false}
                          helperText={errors.supplierRef || ""}
                          label="Ref. Fornecedor"
                          maxLength={120}
                          value={supplierRef}
                          setValue={setSupplierRef}
                        />
                      </Grid>

                      <Grid item lg={6} md={6} sm={12} xs={12}>
                        <SelectErp
                          error={errors.supplierPurchaseUnit ? true : false}
                          helperText={errors.supplierPurchaseUnit || ""}
                          loading={loadingInputs.listUnits || false}
                          label="Unidade Compra"
                          value={supplierPurchaseUnit}
                          setValue={setSupplierPurchaseUnit}
                          optionsList={listUnits}
                          descriptionField="descricao"
                        />
                      </Grid>

                      {mainStockUnit &&
                      supplierPurchaseUnit &&
                      mainStockUnit.id !== supplierPurchaseUnit.id ? (
                        <Grid item lg={6} md={6} sm={6} xs={12}>
                          <TextFieldErp
                            error={
                              errors.supplierConversionFactor ? true : false
                            }
                            helperText={errors.supplierConversionFactor || ""}
                            label="Fator de Conversão"
                            maxLength={120}
                            value={supplierConversionFactor}
                            setValue={setSupplierConversionFactor}
                            mask="decimal"
                            decimals={5}
                          />
                        </Grid>
                      ) : (
                        <></>
                      )}

                      <Grid item lg={6} md={6} sm={12} xs={12}>
                        <TextFieldErp
                          error={errors.supplierDescription ? true : false}
                          helperText={errors.supplierDescription || ""}
                          label="Descrição no Fornecedor"
                          maxLength={120}
                          value={supplierDescription}
                          setValue={setSupplierDescription}
                        />
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
              )}

              <Grid item md={6} xs={12}>
                <Card line="left" lineColor="primary">
                  <HeaderCard>
                    <Grid
                      container
                      alignItems="center"
                      spacing={1}
                      style={{ marginBottom: 14 }}
                    >
                      <Grid item xs>
                        <Chip label="OUTROS FORNECEDORES" bgcolor="secondary" />
                      </Grid>
                      <Grid item flex={1}>
                        <Tooltip title="Adicionar Outro Fornecedor">
                          <IconButtonStyled
                            onClick={() => setOpen(true)}
                            style={{ padding: 8 }}
                          >
                            <Add />
                          </IconButtonStyled>
                        </Tooltip>
                      </Grid>
                    </Grid>
                  </HeaderCard>

                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <TableContent>
                        <Grid container spacing={2}>
                          <Grid item xs={12}>
                            <TableDefault
                              columns={columns}
                              values={dataTable}
                              tableTitle=""
                              rowsPerPage={3}
                            />
                          </Grid>
                        </Grid>
                      </TableContent>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      </Grid>
    </>
  );
}
